(function ($) {
  "use strict";

  // --- Parche para compatibilidad con jQuery 4 (si sigue presente) ---
  if (typeof $.camelCase !== "function") {
    $.camelCase = function (string) {
      return string.replace(/-([a-z])/g, function (all, letter) {
        return letter.toUpperCase();
      });
    };
    console.warn("⚠️ Se aplicó parche de compatibilidad para $.camelCase (jQuery 4)");
  }

  // Spinner
  const spinner = function () {
    setTimeout(function () {
      const $spinner = $("#spinner");
      if ($spinner.length > 0) {
        $spinner.removeClass("show");
      }
    }, 1);
  };
  spinner();

  // Initiate WOW.js
  if (typeof WOW !== "undefined") {
    new WOW().init();
  }

  // Sticky Navbar
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 45) {
      $(".navbar").addClass("sticky-top shadow-sm");
    } else {
      $(".navbar").removeClass("sticky-top shadow-sm");
    }
  });

  // Hero Header carousel -> Slick
  if ($(".header-carousel").length && $.fn.slick) {
    $(".header-carousel").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
      arrows: true,
      fade: true,
      cssEase: "linear",
      adaptiveHeight: true,
      prevArrow:
        '<button type="button" class="slick-prev btn btn-icon"><i class="bi bi-arrow-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next btn btn-icon"><i class="bi bi-arrow-right"></i></button>',
    });
  }

  // Blog carousel -> Slick
  if ($(".blog-carousel").length && $.fn.slick) {
    $(".blog-carousel").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="slick-prev btn btn-icon blog-arrow blog-arrow-prev" aria-label="Anterior"></button>',
      nextArrow:
        '<button type="button" class="slick-next btn btn-icon blog-arrow blog-arrow-next" aria-label="Siguiente"></button>',
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 576, settings: { slidesToShow: 1 } },
      ],
    });
  }

  // Services carousel -> Slick (3 items visibles, responsivo)
  if ($(".services-carousel").length && $.fn.slick) {
    $(".services-carousel").slick({
      autoplay: true,
      autoplaySpeed: 4500,
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="slick-prev service-arrow service-arrow-prev" aria-label="Servicio anterior"><i class="fas fa-chevron-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next service-arrow service-arrow-next" aria-label="Servicio siguiente"><i class="fas fa-chevron-right"></i></button>',
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 992,  settings: { slidesToShow: 2 } },
        { breakpoint: 768,  settings: { slidesToShow: 2 } },
        { breakpoint: 576,  settings: { slidesToShow: 1 } },
      ],
    });
  }



  // Facts counter
  if ($.fn.counterUp) {
    $('[data-toggle="counter-up"]').counterUp({
      delay: 5,
      time: 2000,
    });
  }

  // Back to top button
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 300) {
      $(".back-to-top").fadeIn("slow");
    } else {
      $(".back-to-top").fadeOut("slow");
    }
  });

  $(".back-to-top").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 1500, "easeInOutExpo");
    return false;
  });

  // Drupal messages -> floating toast + modal
  (function handleDrupalMessages() {
    const $messagesRoot = $("[data-drupal-messages]");
    if (!$messagesRoot.length) return;

    // Create container
    const $container = $("<div class='drupal-message-toast-container' aria-live='polite'/>");
    $(document.body).append($container);

    $messagesRoot.find('.messages').each(function () {
      const $msg = $(this).clone();
      const typeClass = $msg.attr('class').split(' ').find(c => c.indexOf('messages--') === 0) || 'messages--status';
      // ensure --msg-accent is set
      let accent = getComputedStyle(document.documentElement).getPropertyValue('--bs-primary') || '#0d6efd';
      if (typeClass.indexOf('status') !== -1) accent = getComputedStyle(document.documentElement).getPropertyValue('--bs-success') || '#198754';
      if (typeClass.indexOf('warning') !== -1) accent = getComputedStyle(document.documentElement).getPropertyValue('--bs-warning') || '#ffc107';
      if (typeClass.indexOf('error') !== -1) accent = getComputedStyle(document.documentElement).getPropertyValue('--bs-danger') || '#dc3545';

      const $toast = $("<div class='drupal-message-toast' role='status'></div>");
      $toast.css('--msg-accent', accent.trim());

      const $body = $("<div class='toast-body'></div>").append($msg.html());
      const $close = $("<button class='toast-close' aria-label='Cerrar'>&times;</button>");

      $toast.append($body).append($close);
      $container.append($toast);

      // Auto dismiss: longer for error
      const autoDismiss = typeClass.indexOf('error') !== -1 ? 10000 : 6000;
      const timer = setTimeout(() => { $toast.fadeOut(250, () => $toast.remove()); }, autoDismiss);

      $close.on('click', function (e) { e.stopPropagation(); clearTimeout(timer); $toast.remove(); });

      // Click to open modal
      $toast.on('click', function () {
        clearTimeout(timer);
        const $overlay = $("<div class='drupal-message-modal-overlay' role='dialog' aria-modal='true'></div>");
        const $modal = $("<div class='drupal-message-modal'></div>");
        const $modalClose = $("<button class='modal-close' aria-label='Cerrar'>&times;</button>");
        $modal.append($modalClose).append($msg.clone().wrap('<div/>').parent().html());
        $overlay.append($modal);
        $(document.body).append($overlay);

        $modalClose.on('click', function () { $overlay.remove(); });
        $overlay.on('click', function (ev) { if (ev.target === this) $overlay.remove(); });
      });
    });

    // Remove original messages from DOM to avoid duplication
    $messagesRoot.empty();
  })();

  // Debug info en consola
  console.log("jQuery version:", $.fn.jquery);
  console.log(
    "jQuery script src:",
    Array.from(document.querySelectorAll('script[src*="jquery"]')).map((s) => s.src)
  );

})(jQuery);
